import * as StaticPagesActions from "./staticPages.actions";
import * as _ from "lodash";

export interface State {
  static_pages: any;
  cookiesConsentReopenTimestamp: any;
}

const initialState: State = {
  static_pages: null,
  cookiesConsentReopenTimestamp: null,
};

export function requestsErrorHandlingReducer(
  state = initialState,
  action: StaticPagesActions.StaticPagesActions
) {
  switch (action.type) {
    case StaticPagesActions.SET_STATIC_PAGES:
      return {
        ...state,
        static_pages: action.payload,
      };

    case StaticPagesActions.CLEAR_STATIC_PAGES:
      return {
        ...state,
        static_pages: null,
        cookiesConsentReopenTimestamp: null,
      };

    case StaticPagesActions.SET_COOKIES_CONSENT_REOPEN_TIMESTAMP:
      return {
        ...state,
        cookiesConsentReopenTimestamp: action.payload,
      };

    default:
      return state;
  }
}
